<template>
  <div class="superadmin-page">
    <aside class="brand-panel">
      <div class="brand-inner">
        <div class="brand-mark">
          <img class="brand-logo" :src="defaultLogo" alt="" />
          <span class="brand-name">{{ brandName }}</span>
        </div>

        <h1 class="brand-title">{{ t('loginPage.superadminPageTitle') }}</h1>
        <p class="brand-desc">{{ t('loginPage.superadminPageDesc') }}</p>

        <ul class="brand-features">
          <li v-for="item in features" :key="item">{{ item }}</li>
        </ul>

        <p class="brand-footer">© {{ year }} {{ brandName }}</p>
      </div>
    </aside>

    <main class="auth-panel">
      <div class="auth-shell">
        <hc-superadmin-login />
      </div>
    </main>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import hcSuperadminLogin from './components/hc-superadmin-login.vue'
import defaultLogo from '@/assets/logo.png'
import { DEFAULT_BRAND_NAME } from '@/utils/tenantBranding.js'
import { usePageI18n } from '@/composables/usePageI18n.js'

const brandName = DEFAULT_BRAND_NAME
const year = new Date().getFullYear()

const applyLabels = () => {}
const { t } = usePageI18n(applyLabels)

const features = computed(() => [
  t('loginPage.superFeature1'),
  t('loginPage.superFeature2'),
  t('loginPage.superFeature3'),
])
</script>

<style lang="less" scoped>
.superadmin-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  background: #fafafa;
  overflow: hidden;
}

.brand-panel {
  position: relative;
  flex: 1;
  min-width: 0;
  display: none;
  background: #ffffff;
  border-right: 1px solid #f4f4f5;

  @media (min-width: 960px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #6366f1 0%, #818cf8 100%);
  }
}

.brand-inner {
  max-width: 400px;
  padding: 48px 56px;
}

.brand-mark {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 40px;
}

.brand-logo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  object-fit: cover;
}

.brand-name {
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
  letter-spacing: 0.01em;
}

.brand-title {
  margin: 0 0 16px;
  font-size: clamp(26px, 2.8vw, 32px);
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0.02em;
  color: #18181b;
}

.brand-desc {
  margin: 0 0 36px;
  font-size: 15px;
  line-height: 1.7;
  color: #71717a;
}

.brand-features {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.brand-features li {
  position: relative;
  padding-left: 18px;
  font-size: 14px;
  line-height: 1.5;
  color: #52525b;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 8px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #6366f1;
  }
}

.brand-footer {
  margin: 48px 0 0;
  font-size: 12px;
  color: #a1a1aa;
}

.auth-panel {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  background: #fafafa;
}

.auth-shell {
  width: 100%;
  max-width: 420px;
}
</style>
